import React from 'react';
import './floatingEventInfo.module.scss';

import iconHuman from '../images/icon-human.png';
import iconCalendar from '../images/icon-calendar.png';
import iconPlace from '../images/icon-place.png';
import iconMoney from '../images/icon-money.png';
import { EventDetails, EventStatus, UserEventReservationStatus } from '../../../types/event';
import { SimpleDate, SimpleTimeRange } from '../../../../admin/components/date/TimeRange';
import { EventStatusUtils } from '../utils/EventStatusUtils';
import { getLocationName } from '../../../../mainv3/types/location';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { EventButton } from './EventButton';
import { EventWaitlistToggleButton } from '../../../../mainv3/components/organisms/events/components/EventWaitlistToggleButton';
import { EventWaitlistDescription } from '../../../../mainv3/components/molecules/event_waitlists/EventWaitlistDescription';
import { EventWaitlistState } from '../../../../mainv3/components/organisms/events/states/EventWaitlistState';
import { LoaderRow } from '../../../../mainv3/components/atoms/layout/LoaderRow';

type Props = {
  event: EventDetails;
  membershipAvailable: boolean;
  eventStatus: EventStatus;
  userEventReservationStatus: UserEventReservationStatus;
  eventWaitlistState: EventWaitlistState;
  loading: boolean;
  // INNOVATIVE WOMEN'S SUMMIT のみ応募者数の表示をフラグ制御にする
  // https://sheinc.atlassian.net/browse/SHE-5091
  hideReservationCount: boolean;
};

export const FloatingEventInfo = (props: Props) => {
  const { event, eventStatus, userEventReservationStatus, eventWaitlistState, loading, hideReservationCount } = props;
  if (loading) {
    return (
      <div id="floating-event-info" styleName="container floating-menu">
        <LoaderRow />
      </div>
    );
  }
  return (
    <div id="floating-event-info" styleName="container floating-menu">
      <div styleName="row">
        <div styleName="left-column">
          <img src={iconCalendar} styleName="icon" />
        </div>
        <div styleName="right-column">
          <div styleName="hours">
            <SimpleDate date={event.starts_at} />
            <SimpleTimeRange range={event} />
          </div>
        </div>
      </div>
      <div styleName="row">
        <div styleName="left-column">
          <img src={iconPlace} styleName="icon" />
        </div>
        <div styleName="right-column">
          <div styleName="location">{getLocationName(event.location)}</div>
        </div>
      </div>
      {!EventStatusUtils.isEventFreeForUser(
        event,
        userEventReservationStatus,
        GlobalStatesV3.currentUser.currentUser
      ) && (
        <>
          <div styleName="row">
            <div styleName="left-column">
              <img src={iconMoney} styleName="icon" data-testid="price" />
            </div>
            <div styleName="right-column">
              <div styleName="ticket-count">
                {event.applied_price > 0 ? (
                  <span>参加費 {event.applied_price.toLocaleString()} 円（税抜）</span>
                ) : (
                  <span>無料</span>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {!EventStatusUtils.isEventFull(event) &&
        // INNOVATIVE WOMEN'S SUMMIT のみ応募者数の表示をフラグ制御にする
        // https://sheinc.atlassian.net/browse/SHE-5091
        !hideReservationCount && (
          <div styleName="row">
            <div styleName="left-column">
              <img src={iconHuman} styleName="icon" />
            </div>
            <div styleName="right-column">
              <div styleName="reservation-count">
                申込者
                {event.active_reservation_count} / {event.capacity}名
              </div>
            </div>
          </div>
        )}
      <div styleName="button">
        <EventButton
          isSignedIn={GlobalStatesV3.currentUser.isSignedIn()}
          loading={loading}
          event={event}
          eventStatus={eventStatus}
          userEventReservationStatus={userEventReservationStatus}
        />
      </div>
      {!loading &&
        userEventReservationStatus.hasAffordableTokenForNow &&
        eventWaitlistState.canShowWaitlist(event, userEventReservationStatus.reserved) && (
          <>
            <div styleName="button">
              <EventWaitlistToggleButton
                event={event}
                reserved={userEventReservationStatus.reserved}
                eventWaitlistState={eventWaitlistState}
              />
            </div>
            <EventWaitlistDescription />
          </>
        )}
    </div>
  );
};
